export default __webpack_public_path__ + "navigation-examples-route-lines-styling-960-d62ac68ae943facc738facaeba8236f2.png";